import { privateHttp } from "@/shared/http/private-http";
import type { OrderDetails, OrderHistory, RepeatOrderResult } from "../types/order.dto";

/** GET /customer/orders/:cpfCnpj — histórico paginado de pedidos. */
export async function getOrderHistory(
    cpfCnpj: string,
    params?: { page?: number; limit?: number }
): Promise<OrderHistory> {
    const { data } = await privateHttp.get<OrderHistory>(`/customer/orders/${cpfCnpj}`, { params });
    return data;
}

/** GET /customer/orders/:cpfCnpj/:orderId — detalhes de um pedido. */
export async function getOrderDetails(cpfCnpj: string, orderId: number): Promise<OrderDetails> {
    const { data } = await privateHttp.get<OrderDetails>(`/customer/orders/${cpfCnpj}/${orderId}`);
    return data;
}

/**
 * POST /customer/orders/:orderId/repeat — adiciona os itens do pedido ao
 * carrinho da sessão. `storeId` é a loja ativa do comprador: preço e estoque
 * são validados contra ela (itens indisponíveis voltam em `skippedItems`).
 */
export async function repeatOrder(orderId: number, storeId?: number): Promise<RepeatOrderResult> {
    const { data } = await privateHttp.post<RepeatOrderResult>(
        `/customer/orders/${orderId}/repeat`,
        storeId && storeId > 0 ? { storeId } : {}
    );
    return data;
}
